module.exports = __webpack_public_path__ + "media/images/social-media/linkedin_white-9cc797a7440bd45a2d92a85973663245.svg";